import {
    FETCH_RECOGNIZED_SENDERS_REQUEST,
    FETCH_RECOGNIZED_SENDERS_SUCCESS,
    FETCH_RECOGNIZED_SENDERS_FAILURE,
    UPDATE_RECOGNIZED_SENDERS_SUCCESS
} from '../actions/types/recognized-senders-action-types';

import { combineReducers } from 'redux';

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_RECOGNIZED_SENDERS_REQUEST:
            newState = true;
            break;
        case FETCH_RECOGNIZED_SENDERS_SUCCESS:
        case FETCH_RECOGNIZED_SENDERS_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function byId( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_RECOGNIZED_SENDERS_SUCCESS:
            if( action.domain ){
                newState = {
                    ...state,
                    [action.domain]: {
                        ...action.byId
                    }
                };
            }
            else if( action.senderId ){
                newState = {
                    ...state,
                    [action.senderId]: {
                        ...action.byId
                    }
                };
            }
            else{
                newState = state;
            }
            break;
        case UPDATE_RECOGNIZED_SENDERS_SUCCESS:
            if( action.domain ){
                newState = {
                    ...state,
                    [action.domain]: {
                        ...state[action.domain],
                        ...action.byId
                    }
                };
            }
            else if( action.senderId ){
                newState = {
                    ...state,
                    [action.senderId]: {
                        ...state[action.senderId],
                        ...action.byId
                    }
                };
            }
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    byId,
    isLoading,
} );
